export default ({ priceProp, currencyProp, minimumFractionDigits = 0 }) =>
  (props) => {
    return props.intl.formatNumber(
      props[priceProp],
      { style: 'currency', currency: props[currencyProp], minimumFractionDigits }
    )
  };
